import React from 'react'
import logo from 'Placements/Assets/img/logo_yazigi.png'

function Header() {
    return (
        <header className="header-home">
            <div className="container-logo">
                <img src={logo} className="logo" alt="Logo Yázigi" />
            </div>
            <h1 className="header-titulo">
                Teste de nível
            </h1>
        </header>
    )
}

export default Header
